import axios from 'axios';

const baseURL = import.meta.env.VITE_BASE_API || 'https://aiot-qa.zuowei.com:9999/';

export async function getCaptchaApi(randomNum: string) {
  const res = await axios.get(`${baseURL}auth/code/image?randomStr=${randomNum}`, {
    responseType: 'blob'
  });
  return res;
}
